export { default } from "./clamp.js";